import ReactRailsUJS from 'react_ujs'
import { setReactConstructor } from '../helpers/ViteHelper'
import mountEditAssemblyCardInstance from '../helpers/mountEditAssemblyCardInstance'
import baseFrontModules from '../helpers/entrypoint_modules/baseFront'

mountEditAssemblyCardInstance()

const modules = import.meta.globEager([
  '~/components/cms/docs/tech_doc/DocsTechDocBody.{js,jsx,ts,tsx}',
])

const mergedModules = Object.assign(modules, baseFrontModules)

setReactConstructor(ReactRailsUJS, mergedModules)
